/* eslint-disable import/no-named-as-default */
import React from 'react';
import PropTypes from 'prop-types';
import IconMenu from 'material-ui/IconMenu';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as statusActions from 'actions/statusActions';
import * as workOrderActions from 'actions/workOrderActions';
import * as userActions from 'actions/userActions';
import * as siteActions from 'actions/siteActions';
import FlatButton from 'material-ui/FlatButton';
import ArrivalTimeDialog from 'workOrderComponents/ArrivalTimeDialog';
import statusConfig from 'status/statusConfig';
import MenuItem from 'material-ui/MenuItem';
import {withRouter} from 'react-router-dom';
import * as colors from 'material-ui/styles/colors';
import FontIcon from 'material-ui/FontIcon';
import {FormattedRelative} from 'react-intl';
import Divider from 'material-ui/Divider';
import { getOidc, getAccessTokenFromOidc } from 'utils/userManager';

export class Status extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.toggelStatus = this
            .toggelStatus
            .bind(this);

        this.refreshStatus = this
            .refreshStatus
            .bind(this);

        this.goBackToOrder = this
            .goBackToOrder
            .bind(this);

        this.handleMenuToggle = this
            .handleMenuToggle
            .bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const {
            userId, currentUserId, techData,
            statusActions,
            workOrderActions,
            isSelf,
            oidc
        } = nextProps;

        const statusLoading = techData.getIn(['techs', userId, 'statusLoading']);
        const statusWaiting = techData.getIn(['techs', userId, 'statusWaiting']);
        const workOrderLoading = techData.getIn(['techs', userId, 'workOrderLoading']);
        const statusLoadingFinished = techData.getIn(['techs', userId, 'statusLoadingFinished']);
        const assignedServiceOrders = techData.getIn(['techs', userId, 'assignedServiceOrders']);

        const accessToken = getAccessTokenFromOidc(oidc);
        if (accessToken && !assignedServiceOrders && !workOrderLoading && userId) {
            workOrderActions.workOrderGetTechRouteStarted({userId: userId, isSelf: isSelf});
        }
        const statusWillLoad = (accessToken && userId && !statusLoading && !statusWaiting && !statusLoadingFinished);

        if (statusWillLoad) {
            const channels = [userId];

            if (userId && currentUserId && userId !== currentUserId) {
                channels.push(currentUserId);
            }

            const timeStamp = new Date();
            statusActions.getTechStatusStarted({
                techStatusChange: {
                    userId: userId,
                    techStatusWorkOrder: {
                        workOrderNumber: null,
                        arrivalTime: null
                    },
                    techStatus: "GetStatus"
                },
                channels: channels
            }, userId, timeStamp);
        }
    }

    toggelStatus(action) {
        setTimeout(function () {
            action();
        }, 500);
    }

    refreshStatus(e) {
        e.preventDefault();
        const {statusActions, userId, currentUserId} = this.props;
        const channels = [userId];

        if (userId && currentUserId && userId !== currentUserId) {
            channels.push(currentUserId);
        }

        statusActions.getTechStatusStarted({
            techStatusChange: {
                userId: userId,
                techStatusWorkOrder: {
                    workOrderNumber: null,
                    arrivalTime: null
                },
                techStatus: "GetStatus"
            },
            channels: channels
        }, userId);

    }

    goBackToOrder(e, orderId) {
        e.preventDefault();
        const {history} = this.props;
        history.push(`/work-order-detail/${orderId}`);
    }

    handleMenuToggle(open) {
        const {siteActions, userId} = this.props;
        siteActions.toggleDrawer(`${userId}_techStatus`, open);
    }

    render() {
        const {
            statusActions,
            techData,
            userId,
            buttonTextColor,
            isSelf,
            currentUserId
        } = this.props;

        let statusItems = null;
        const errorMenuItem = null;

        const statusLoading = techData.getIn(['techs', userId, 'statusLoading']);
        const userStatus = techData.getIn(['techs', userId, 'status']);

        const statusLoadingError = techData.getIn(['techs', userId, 'statusLoadingError']);

        let buttonTextColorOverride = buttonTextColor;

        const assignedServiceOrders = techData.getIn(['techs', userId, 'assignedServiceOrders']);
        const assignedOrderIds = assignedServiceOrders
            ? assignedServiceOrders.flatMap((group) => group.get('orderIds') || []).toArray()
            : null;

        statusItems = statusConfig(userId, statusActions, userStatus, isSelf, currentUserId, assignedOrderIds);

        let mainIcon = (
            <FontIcon
                style={{
                color: buttonTextColorOverride || 'white'
            }}
                className="material-icons">{statusItems.icon}</FontIcon>
        );

        let label = statusItems.label;

        if (statusLoading) {
            label = 'Loading...';
            mainIcon = (
                <FontIcon
                    style={{
                    color: buttonTextColorOverride || 'white'
                }}
                    className="material-icons">refresh</FontIcon>
            );
        }

        if (!statusItems) {
            label = 'Unkown Status';
        }

        if (statusLoadingError && !statusLoading) {
            label = statusLoadingError;
            buttonTextColorOverride = colors.red500;
        }

        const menuItems = statusItems
            .menuItems
            .map((item, index) => {

                const icon = (
                    <FontIcon className="material-icons">{item
                            .configItem
                            .get('icon')}</FontIcon>
                );

                return (<MenuItem
                    leftIcon={icon}
                    key={item.key + index}
                    onTouchTap={item.onClick}
                    primaryText={item.primaryText}/>);
            });

        const button = (<FlatButton
            onTouchTap={(e) => e.preventDefault()}
            icon={mainIcon}
            labelStyle={{
            color: buttonTextColorOverride || 'white',
            paddingRight: '0',
            textDecoration: 'underline'
        }}
            fullWidth
            label={label}
            labelPosition="after"/>);

        if (userStatus) {

            const statusWithJob = userStatus.find((item) => {

                if (item.get('status') === 'onjob' || item.get('status') === 'enroute') {

                    return true;
                }

            });

            if (statusWithJob) {
                const viewIcon = (
                    <FontIcon className="material-icons">open_in_browser</FontIcon>
                );
                menuItems.push((<MenuItem
                    key="view_order"
                    leftIcon={viewIcon}
                    onTouchTap={(e) => this.goBackToOrder(e, statusWithJob.get('workOrderNumber'))}
                    primaryText="View Order"/>));
            }
        }

        const refreshIcon = (
            <FontIcon className="material-icons">refresh</FontIcon>
        );

        const clockIcon = (
            <FontIcon className="material-icons">schedule</FontIcon>
        );

        const lastUpdatedText = (
            <span style={{
                fontSize: '12px'
            }}>Last updated &nbsp;
                <FormattedRelative
                    value={techData.getIn(['techs', userId, 'statusLoadedTime']) || new Date()}/></span>
        );

        return (
            <span>
                <IconMenu
                    useLayerForClickAway={true}
                    onRequestChange={this.handleMenuToggle}
                    iconButtonElement={button}>
                    {errorMenuItem}
                    {menuItems}
                    <MenuItem
                        leftIcon={refreshIcon}
                        onTouchTap={this.refreshStatus}
                        primaryText="Refresh Status"/>
                    <Divider/>
                    <MenuItem disabled leftIcon={clockIcon} primaryText={lastUpdatedText}/>
                </IconMenu>
                <ArrivalTimeDialog
                    userId={userId}
                    currentUserId={currentUserId}
                    isSelf={isSelf}/>
            </span>
        );
    }
}

Status.defaultProps = {
    buttonTextColor: 'white'
};

Status.propTypes = {
    oidc: PropTypes.object,
    buttonTextColor: PropTypes.string,
    userId: PropTypes.string,
    currentUserId: PropTypes.string,
    statusActions: PropTypes.object,
    workOrderActions: PropTypes.object,
    techData: PropTypes.object,
    isSelf: PropTypes.bool,
    history: PropTypes.object,
    siteActions: PropTypes.object
};

const mapStateToProps = (state) => {
    return {
        techData: state.get('techData'),
        oidc: getOidc(state),
        site: state.get('site')
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        statusActions: bindActionCreators(statusActions, dispatch),
        workOrderActions: bindActionCreators(workOrderActions, dispatch),
        userActions: bindActionCreators(userActions, dispatch),
        siteActions: bindActionCreators(siteActions, dispatch)

    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Status));



// WEBPACK FOOTER //
// ./src/containers/Status.js